import { DEFAULT_LOCALE, isLocale, type Locale } from '@sjuni/types';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ka from './locales/ka.json';

/**
 * docs/05-ADMIN-DASHBOARD.md — the dashboard is operated by university staff,
 * so its chrome is Georgian first, with English available. Content the admin
 * edits is separately translatable and comes from the API.
 *
 * The admin's own UI language is a user preference (Phase 6); until then it
 * follows the same default as the public site.
 */
export const resources = {
  ka: { translation: ka },
  en: { translation: en },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: ['ka', 'en'],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function applyLocale(locale: Locale): void {
  void i18n.changeLanguage(locale);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
    document.documentElement.dir = 'ltr';
  }
}

export function resolveLocale(value: unknown): Locale {
  return isLocale(value) ? value : DEFAULT_LOCALE;
}

export default i18n;
